export const baseUrl = process.env.REACT_APP_BASE_URL;
export const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
export const overAllPdfReportApi = "/overall-report-pdf";
export const getQueueDataApi = "/sites/queue?id=";
export const getReportApi = process.env.REACT_APP_REPORT_BASE_URL;
export const getToolReportApi = process.env.REACT_APP_TOOL_REPORT_BASE_URL;
export const parichayApi = "/dashboard/dynamicsiteIdfromjainparichay?string=";
export const getSitesByUser = "/sites/byuser?user=";
export const getManualDataApi = "/sites/manual";
export const getDBIMManualQuestionApi = "/sites/dbim-manual-question";
export const liveRefApi = "/liveref";
export const nicLoginApi = "/signin";
export const saveLogsApi = "/savelogs";
export const getFrameWorkQuestionApi = "/questions";
export const parichayLogin = "/parichay/login";
export const saveManualApi = "/sites/savemanual";
export const saveDbimManualApi = "/sites/dbim-manual-save";
export const parichayapiLogout = "/parichay/logout?user=";
export const parichayTokenAuthenticate =
  "/dashboard/parichay-token-valid?user=";
export const checkAuthenticateApi = "/checkAuthenticate";
export const checkReportGenerated = "/check_report_genarate_or_not/";
export const getDBIMOverallApi = "/sites/dbim-overall/";
export const getDBIMReportApi = "/sites/dbim_report/";
export const getOverallDataApi = "/sites/issights-overall/";
export const getSiteInsightApi = "/sites/insights/";
export const logoutApiUrl = "/logout-other-sessions";
export const downloadReportExcel = "/report-xls/";
export const advancedDownloadReportExcel = "/report-xls-overall/";
export const reportGeneratingApi = "/check_report_genarate_or_not_by_site_id/";

//

export const sugamyaDataWebMessage =
  "Accessibility (Sugamya) report was not generated for this site. Please generate the report again";

export const reportProcessingMessage =
  "Your report is currently under processing. Please wait while the operation completes.";
